export default {
    language: "한국어",
    StripeSuccess: {
        loading: "결제를 처리하는 중...",
        successMessage: "구독이 성공적으로 활성화되었습니다!",
        processingError: "결제 처리 실패, 문의해 주세요",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "이메일",
            createdAt: "생성 일자",
            noRecord: "기록 없음",
            loginTime: "로그인 시간",
        },
        orders: {
            title: "주문 내역",
            loading: "로딩 중...",
            refresh: "새로고침",
            orderAmount: "금액",
            points: "포인트",
            createdAt: "생성 일자",
            orderType: "유형",
            status: "상태",
            noOrders: "주문 없음",
            goToSubscription: "포인트 구매",
            freeCredit: "무료 크레딧",
            paidCredit: "유료 크레딧",
            queryOrderFailed: "주문 조회 실패",
            statusPaid: "결제 완료",
            statusPending: "대기 중",
            statusCancelled: "취소됨",
            statusDeactivated: "비활성화됨",
            checkoutUrlNotAvailable: "결제 URL을 가져오지 못했습니다",
            verifyingPayment: "결제 상태 확인 중...",
            paymentSuccess: "결제 성공",
            paymentPending: "주문이 결제 대기 중입니다. 결제를 완료해 주세요",
            paymentFailed: "결제 실패 또는 취소됨",
            paymentStatus: "결제 상태",
            paymentStatusDescription: "결제를 완료하셨습니까?",
            cancelPayment: "결제 취소",
            completedPayment: "결제 완료",
            warning: "경고",
            confirmCancelOrder: "이 주문을 취소하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
            cancel: "취소",
            confirm: "확인",
            cancellingOrder: "주문 취소 중...",
            orderCancelledSuccess: "주문이 취소되었습니다",
            cancelOrderFailed: "주문 취소 실패",
            checkOrderStatusFailed: "주문 상태 확인 실패",
            promptClick: "결제를 계속하려면 \"대기 중\" 상태를 클릭하세요",
        }
    },
    UserFeedback: {
        title: "사용자 후기",
        feedback: "전 세계 창작자 및 전문가들의 AI 이미지 처리 기술에 대한 실제 평가를 들어보세요.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "린 씨",
                profession: "비디오 편집자 & 콘텐츠 크리에이터",
                rating: 5,
                comment: "놀라워요! ClixMagicAI은 정말 빠릅니다! 워터마크가 있는 비디오를 업로드하면 몇 분 안에 품질 손실 없이 워터마크가 제거된 버전을 얻을 수 있어요. 워터마크 제거에 필수적인 도구입니다!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "수 씨",
                profession: "소셜 미디어 마케팅 전문가",
                rating: 5,
                comment: "ClixMagicAI이 내 인스타그램 콘텐츠 라이브러리를 구했어요! 복잡한 워터마크도 정확하게 인식하며, 다른 소프트웨어보다 가장자리 처리가 훨씬 섬세하고 결과물이 더 자연스러워 보입니다."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "첸 씨",
                profession: "쇼트 비디오 콘텐츠 제작자",
                rating: 5,
                comment: "ClixMagicAI으로 워터마크를 제거하는 것은 매우 편리합니다. 출근길에 틱톡 콘텐츠를 처리한 후 사무실에 도착하자마자 HD 버전을 다운로드할 수 있어요! 미디어 전문가들에게 정말 좋은 도구입니다."
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "황 씨",
                profession: "그래픽 디자이너 & 비주얼 크리에이티브 디렉터",
                rating: 5,
                comment: "디자이너로서 매우 만족합니다! 클라이언트가 제공한 로고가 있는 이미지를 처리할 때, 배경 텍스처가 자연스럽게 복원되고 포토샵 흔적 없이 처리되어 후처리 시간을 절약할 수 있어요."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "에밀리 씨",
                profession: "프리랜서 디지털 콘텐츠 크리에이터",
                rating: 5,
                comment: "보물을 발견했어요! 멤버십 가격이 다른 워터마크 제거 제품들보다 훨씬 저렴한데도 워터마크 제거 효과는 오히려 더 좋습니다. 특히 그라데이션 투명 워터마크 처리에 뛰어난 장점이 있어요."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "로버트슨 씨",
                profession: "기업 교육 과정 개발자",
                rating: 5,
                comment: "ClixMagicAI은 설치가 필요 없어서 정말 편리합니다! 회사 컴퓨터에는 소프트웨어 설치 권한 제한이 있는데, 이제 브라우저만으로도 강의 자료를 처리할 수 있어 언제 어디서나 사용할 수 있습니다."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "저우 씨",
                profession: "주부 & 커뮤니티 미디어 편집자",
                rating: 5,
                comment: "인터페이스가 너무 간단해서 할머니도 사용할 수 있을 정도예요! 포토샵 같은 전문 소프트웨어를 배울 시간이 없다면 ClixMagicAI을 꼭 시도해보세요. 저 같은 기술 초보자에게 완벽합니다. 하하~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "존슨 씨",
                profession: "이커머스 비주얼 전략가",
                rating: 5,
                comment: "ClixMagicAI은 정말 강력해요. 이미지, 비디오, 작은 물체, 사람, 텍스트 등을 제거할 수 있어요. 기능이 포괄적이라 모두에게 추천합니다~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "팡 씨",
                profession: "사진 애호가 & 온라인 콘텐츠 공유자",
                rating: 5,
                comment: "와우~ 드디어 이미지 품질을 손상시키지 않는 워터마크 제거 도구를 찾았어요! 마법처럼 놀라워요~ 사진 편집이 더 이상 문제가 아닙니다! 강력히 추천합니다!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "윌리엄스 씨",
                profession: "온라인 교육 강사",
                rating: 5,
                comment: "워터마크 위치 기억 기능이 매우 유용합니다! 시리즈 강의 비디오를 처리할 때 반복적으로 선택할 필요가 없어 최소 30분의 작업 시간을 절약하고 교육 준비 효율성을 크게 향상시켰습니다."
            }
        ]
    },
    Order: {
        purchasePoints: "포인트 구매",
        subtitle: "워터마크 제거 서비스를 이용하기 위한 포인트 패키지를 선택하세요",
        loginReminderDesc: "포인트 선택 및 구매를 위해 로그인하세요",
        freeTag: "무료",
        freePlan: "무료 플랜",
        autoActivated: "로그인 후 자동 활성화",
        points: "포인트",
        autoIncluded: "무료 제공",
        discount: "할인",
        purchase: "지금 구매",
        paymentStatusDescription: "결제를 완료하셨나요?",
        paymentNotCompleted: "결제 미완료",
        queryOrderFailed: "주문 상태 확인 실패",
        cancelPayment: "결제 취소",
        completedPayment: "결제 완료",
        warning: "경고",
        confirmCancelOrder: "이 주문을 취소하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
        cancel: "취소",
        confirm: "확인",
        selectProductFirst: "먼저 패키지를 선택해주세요",
        creatingOrder: "주문 생성 중...",
        orderCreated: "주문이 생성되었습니다",
        createOrderFailed: "주문 생성 실패",
        checkoutUrlNotAvailable: "결제 링크 획득 실패",
        cancellingOrder: "주문 취소 중...",
        orderCancelledSuccess: "주문이 취소되었습니다",
        cancelOrderFailed: "주문 취소 실패",
        verifyingPayment: "결제 상태 확인 중...",
        paymentSuccess: "결제 성공",
        paymentPending: "결제 대기 중, 결제를 완료해주세요",
        paymentFailed: "결제 실패 또는 취소됨",
        checkOrderStatusFailed: "주문 상태 확인 실패",
        quickStart: "빠른 시작",
        shortTerm: "단기 사용",
        recommended: "추천",
        bestValue: "최고 가치",
    },
    Login: {
        title: "로그인",
        subtitle: "소셜 계정으로 빠른 로그인",
        memberTip: "더 많은 기능을 이용하려면 로그인하세요",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "GitHub 계정으로 로그인"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Google 계정으로 로그인"
            }
        ],
        error: {
            serverError: "서버 오류, 나중에 다시 시도하세요",
            networkError: "네트워크 오류, 연결을 확인하세요"
        }
    },
    OAuthCallback: {
        loading: "로그인 요청 처리 중",
        pleaseWait: "잠시만 기다려주세요, 로그인 정보 확인 중...",
        error: "로그인 실패",
        backToHome: "홈으로 돌아가기",
        success: "로그인 성공",
        redirecting: "홈페이지로 이동 중..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "가격",
            faq: "자주 묻는 질문",
        },
        login: "로그인",
        userMenu: {
            account: "계정",
            logout: "로그아웃",
            credit: "포인트",
            freeCredit: "무료",
            paidCredit: "구매됨",
            nextUpdate: "다음 포인트 업데이트",
            language: "언어",
            theme: "테마",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "ClixMagicAI 기능",
        advs: [
            {
                title: "AI 자동 인식 엔진: 방해 요소 자동 감지",
                desc: "딥러닝 알고리즘을 기반으로 이미지/비디오의 워터마크, 텍스트, 얼굴 및 복잡한 배경 요소를 수동 표시 없이 자동으로 인식합니다. 인스타그램, 틱톡 등의 플랫폼 형식을 지원하며, 개인 데이터를 엄격히 보호합니다.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "워터마크 제거"
            },
            {
                title: "이미지 정화 마스터: 로고/날짜 스탬프 신속 제거, 품질 유지",
                desc: "브랜드 워터마크, 촬영 날짜, 스티커 등 방해 요소를 정확히 제거합니다. AI가 자동으로 배경 텍스처를 복원하여 처리 후 이미지가 원본처럼 자연스럽게 보이며, 소셜 미디어 게시에 완벽합니다.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "워터마크 제거"
            },
            {
                title: "동적 워터마크 제거: 스크롤 자막/플랫폼 로고 삭제",
                desc: "유튜브 아웃트로 카드, 틱톡 동적 워터마크, 스크롤 텍스트를 원클릭으로 제거합니다. AI 스마트 추적이 각 프레임을 처리하여 부드러운 4K 고품질 비디오를 출력하며, MP4/MOV 등 주요 형식을 지원합니다.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "워터마크 제거"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "AI 기반 워터마크 제거 도구로 이미지, 비디오 및 파일에서 빠르고 자연스럽게 워터마크를 제거합니다.",
        fileTypes: {
            image: '이미지 워터마크 제거',
            pdf: 'PDF 워터마크 제거',
            video: '비디오 워터마크 제거'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "일일 무료 체험", icon: "fa-gift" },
            { id: "imageTag", text: "이미지 워터마크 제거", icon: "fa-image" },
            { id: "videoTag", text: "비디오 워터마크 제거", icon: "fa-video" },
            { id: "aiPoweredTag", text: "AI 기술 사용", icon: "fa-robot" },
            { id: "noRegTag", text: "로그인 후 사용", icon: "fa-user-check" },
        ],
        videoPromt: "곧 출시됩니다!",
        videoDesc: "더 나은 경험을 제공할 비디오 워터마크 제거 기능을 개발 중입니다."
    },
    Footer: {
        social: {
            title: "문의하기",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:clixmagicai@gmail.com",
                    text: "clixmagicai@gmail.com"
                },
            ]
        },
        termsTitle: "법적 조항",
        terms: [
            {
                id: 1,
                title: "개인정보 정책",
                link: "/privacy"
            },
            {
                id: 2,
                title: "서비스 약관",
                link: "/terms"
            },
            {
                id: 3,
                title: "쿠키 정책",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI 모든 권리 보유."
    },
    Task: {
        image: {
            imageSupportText: 'jpg, jpeg, png, webp, heic, heif 형식 지원, 파일당 최대 10MB',
            imageFileTooLarge: '파일 크기 제한 초과 (최대 10MB)',
            invalidImageType: '지원되지 않는 이미지 형식, JPG, JPEG, PNG, WEBP, HEIC 또는 HEIF 형식을 업로드하세요',
            imageWillCost: '소비: 1 포인트',
            hiecSupportText: 'HEIC/HEIF 형식은 제출 시 자동으로 PNG로 변환됩니다',
            hiecSuccess: 'HEIC/HEIF 형식 변환 성공',
            hiecFailed: 'HEIC/HEIF 형식 변환 실패',
            processingImageTip: '이미지 처리 중입니다. 잠시만 기다려주세요...',
            guide: {
                title: '사용 가이드',
                step1: '이미지 업로드',
                step2: '워터마크 영역 브러시 또는 자동 인식 기능 사용',
                step3: '제출 클릭'
            }
        },
        common: {
            remaining: '남은 포인트',
            nextUpdate: '다음 포인트 업데이트',
            handleError: '파일 처리 오류, 다른 파일을 시도하세요',
            uploadFailed: '파일 업로드 실패',
            dragText: '이 곳에 파일을 끌어다 놓거나',
            clickText: '클릭하여 업로드',
            loginRequired: '파일 업로드 전 로그인해주세요',
            noRemainingTasks: '모든 포인트가 소진되었습니다',
            loginNow: '지금 로그인',
            upgradeNow: '지금 포인트 구매',
            taskSubmitSuccess: '작업 제출 성공',
            taskSubmitError: '작업 제출 실패',
            taskRetrySuccess: '작업 재시도 제출 성공!',
            taskRetryError: '작업 재시도 제출 실패!',
            processing: '처리 중',
            submit: '제출',
            waiting: '대기 중',
            completed: '완료됨',
            failed: '실패',
            cancelled: '취소됨',
            url_not_found: '링크 획득 실패',
            deleted: '삭제됨',
            refreshSuccess: '작업 목록 새로고침됨',
            refreshFailed: '작업 목록 새로고침 실패',
            deleteSuccess: '작업 삭제 성공',
            deleteFailed: '작업 삭제 실패',
            waitingForCompletion: '현재 작업이 완료될 때까지 기다려 주세요',
            loadOriginalImageFailed: '원본 이미지 로드 실패, 다시 시도하세요',
            downloadFailed: '다운로드 실패',
            startingDownload: '다운로드 시작 중...',
            noTasks: '작업 없음',
            refresh: '새로고침',
            sort: '정렬',
            noFilterTasks: '{filter} 작업 없음',
            compare: '비교 보기',
            originalImage: '원본 이미지',
            processedImage: '처리된 이미지',
            dragToCompare: '👈 좌우로 드래그하여 비교 👉',
            cancel: "취소",
            delete: "삭제",
            retry: "재시도",
            download: "다운로드",
            createAt: "생성일",
            expiredAt: "만료일",
        },
        video: {
            videoSupportText: 'mp4, mov, avi, mkv 형식 지원, 파일당 최대 100MB',
            videoFileTooLarge: '파일 크기 제한 초과 (최대 100MB)',
            invalidVideoType: '지원되지 않는 비디오 형식, MP4, MOV, AVI 또는 MKV 형식을 업로드하세요',
            videoWillCost: '소비: 3 포인트',
            processingVideoTip: '비디오 처리 중입니다. 잠시만 기다려주세요...',
            guide: {
                step1: '비디오 업로드',
                step2: '워터마크 유형 선택 및 영역 지정',
                step3: '제출 클릭'
            },
            annotationTools: '워터마크 주석 도구',
            selectType: '워터마크 유형 선택',
            deleteAnnotation: '주석 삭제',
            clearAllAnnotations: '모든 주석 지우기',
            annotationHelp: '주석 도움말',
            dragTip: '드래그하여 워터마크 영역 그리기',
            resizeTip: '워터마크에 맞게 크기 조정',
            moveTip: '생성된 주석 이동 가능',
            processing: '처리 중',
            submit: '제출',
            taskSubmitSuccess: '작업 제출 성공',
            taskSubmitError: '작업 제출 실패',
            retryTaskTip: '작업 재시도 제출 성공',
            retryFailed: '작업 재시도 실패',
            uploadFailed: '업로드 실패',
            staticWatermarkDesc: '고정 위치의 정적 워터마크에 적합',
            normalWatermarkDesc: '일반 고정 워터마크에 적합',
            dynamicWatermarkDesc: '변화하는 동적 워터마크에 적합',
            moveWatermarkDesc: '이동이 필요한 워터마크에 적합'
        },
    },
    Router: {
        home: "홈",
        terms: "서비스 약관",
        privacy: "개인정보 보호정책",
        cookie: "쿠키 정책",
        user: "사용자 센터",
    },
    Terms: {
        "tabs": {
            "terms": "이용약관",
            "privacy": "개인정보 보호정책",
            "cookies": "쿠키 정책"
        },
        "lastUpdated": "최종 업데이트: 2025년 5월 20일",
        "terms": {
            "sections": [
                {
                    "title": "1. 소개",
                    "description": "ClixMagicAI에 오신 것을 환영합니다. 당사의 서비스를 이용하면 이 이용약관에 동의하는 것입니다. 주의 깊게 읽어주세요."
                },
                {
                    "title": "2. 서비스 설명",
                    "description": "ClixMagicAI은 이미지, 비디오에서 워터마크를 제거하기 위한 AI 기반 도구를 제공합니다. 당사의 서비스는 다음과 같은 합법적인 용도로 사용됩니다:",
                    "items": [
                        "자신의 콘텐츠에서 워터마크 제거",
                        "수정할 적절한 권한이 있는 콘텐츠에서 워터마크 제거",
                        "교육 및 연구 목적"
                    ]
                },
                {
                    "title": "3. 사용자 책임",
                    "description": "ClixMagicAI을 사용함으로써 다음에 동의합니다:",
                    "items": [
                        "본인이 소유하거나 수정할 적절한 권한이 있는 콘텐츠만 업로드",
                        "불법적인 목적이나 법률을 위반하는 용도로 당사 서비스 사용 금지",
                        "당사의 보안 조치나 사용 제한을 우회하려는 시도 금지",
                        "타인의 지적 재산권을 침해하기 위해 당사 서비스 사용 금지"
                    ]
                },
                {
                    "title": "4. 계정 조건",
                    "description": "당사 서비스의 일부 기능을 사용하려면 계정을 만들어야 할 수 있습니다. 로그인하기 위해 Google 또는 GitHub 계정을 사용할 수 있습니다. 다음에 대한 책임이 있습니다:",
                    "items": [
                        "계정 보안 유지",
                        "계정에서 발생하는 모든 활동",
                        "정확한 계정 정보 제공(아바타, 이메일, 사용자 이름 및 사용자 ID 포함하되 이에 국한되지 않음)"
                    ]
                },
                {
                    "title": "5. 무료 및 유료 서비스",
                    "description": "ClixMagicAI은 워터마크 제거 기능에 접근하기 위한 무료 기본 할당량과 유연한 포인트 구매 옵션을 제공합니다:",
                    "items": [
                        "기본 할당량: 모든 사용자는 매일 자동으로 10개의 무료 포인트를 받으며, 이는 콘텐츠 처리에 사용할 수 있습니다",
                        "포인트 소비 규칙: 이미지 워터마크 제거는 작업당 1포인트, 비디오 워터마크 제거는 작업당 3포인트를 소비합니다",
                        "포인트 구매: 더 많은 사용을 위해 포인트 패키지를 구매할 수 있으며, 구매한 모든 포인트는 만료 제한 없이 영구적으로 유효합니다",
                        "환불 정책: 디지털 서비스의 즉각적이고 가상적인 특성으로 인해 성공적으로 구매한 포인트는 환불되지 않습니다"
                    ]
                },
                {
                    "title": "6. 지적 재산권",
                    "description": "당사가 만든 모든 소프트웨어, 디자인 및 콘텐츠를 포함한 ClixMagicAI 서비스는 당사의 지적 재산입니다. 허가 없이 당사 서비스를 기반으로 복사, 수정 또는 파생 작업을 만들 수 없습니다."
                },
                {
                    "title": "7. 책임 제한",
                    "description": "ClixMagicAI은 어떠한 종류의 보증 없이 '있는 그대로' 서비스를 제공합니다. 당사는 당사 서비스 사용으로 인한 손해에 대해 책임을 지지 않습니다."
                },
                {
                    "title": "8. 약관 변경",
                    "description": "당사는 언제든지 이 약관을 수정할 수 있습니다. 약관 변경 후 ClixMagicAI을 계속 사용하는 것은 수정된 약관에 동의함을 의미합니다."
                },
                {
                    "title": "9. 해지",
                    "description": "귀하의 행동이 이 약관을 위반하거나 다른 사용자, 당사 또는 제3자에게 해를 끼친다고 판단되는 경우, 당사는 사전 통지 없이 즉시 당사 서비스에 대한 액세스를 종료하거나 중단할 권리를 보유합니다."
                },
                {
                    "title": "10. 준거법",
                    "description": "이 약관은 법률 충돌 조항에 관계없이 당사 회사 등록 장소의 적용 법률에 따라 규율됩니다."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. 소개",
                    "description": "ClixMagicAI에서는 귀하의 개인정보를 소중히 여기며 개인 데이터 보호에 최선을 다하고 있습니다. 이 개인정보 보호정책은 당사 웹사이트 및 서비스를 사용할 때 당사가 귀하의 정보를 수집, 사용 및 보호하는 방법을 설명합니다. 당사 웹사이트에 접속하거나 서비스를 이용함으로써, 귀하는 이 정책에 설명된 데이터 처리 관행에 동의하게 됩니다. 당사는 적용 가능한 데이터 보호 규정을 준수합니다."
                },
                {
                    "title": "2. 수집하는 정보",
                    "description": "당사는 다음과 같은 유형의 정보를 수집할 수 있습니다:",
                    "items": [
                        { "bold": "계정 정보", "text": "Google 또는 GitHub를 통해 로그인할 때 제공되는 사용자 아바타, 이메일 주소, 사용자 이름 및 사용자 ID" },
                        { "bold": "사용 데이터", "text": "접근한 기능 및 사용 시간을 포함하여 당사 서비스 사용 방법에 관한 정보" },
                        { "bold": "업로드된 콘텐츠", "text": "처리를 위해 업로드한 이미지, 비디오 또는" },
                        { "bold": "결제 정보", "text": "구독 구매 시 결제 정보(Creem/Stripe/PayPal과 같은 제3자 결제 게이트웨이를 통해 안전하게 처리되며, 당사는 결제 상태 기록만 유지)" },
                        { "bold": "기술 데이터", "text": "IP 주소, 브라우저 유형, 장치 정보" }
                    ]
                },
                {
                    "title": "3. 정보 사용 방법",
                    "description": "당사는 귀하의 정보를 다음과 같이 사용합니다:",
                    "items": [
                        { "text": "서비스 제공, 유지 및 개선" },
                        { "text": "거래 처리 및 완료" },
                        { "text": "기술 알림 및 지원 메시지 전송" },
                        { "text": "귀하의 의견 및 질문에 응답" },
                        { "text": "사용자 경험을 향상시키기 위한 사용 패턴 분석, 서비스 목적 달성에 필요한 범위 내에서만 개인 데이터 처리" },
                        { "text": "개인 데이터의 저장 기간이 필요한 시간을 초과하지 않도록 보장" },
                        { "text": "사기 또는 불법 활동 방지" }
                    ]
                },
                {
                    "title": "4. 데이터 보안",
                    "description": "당사는 귀하의 개인 정보를 보호하기 위해 업계 표준 보안 조치를 구현합니다:",
                    "items": [
                        { "text": "전송 및 저장 중 파일에 대한 AES-256 암호화" },
                        { "text": "제로 지식 아키텍처를 사용한 민감한 데이터 처리" },
                        { "text": "일일 보안 로그 감사 및 취약점 스캔" },
                        { "text": "직원 접근은 최소 권한 원칙을 따름" }
                    ]
                },
                {
                    "title": "5. 데이터 공유",
                    "description": "당사는 귀하의 개인 정보를 판매하지 않습니다. 다음과 정보를 공유할 수 있습니다:",
                    "items": [
                        { "bold": "서비스 제공업체", "text": "특정 서비스에 필요한 데이터 처리로 제한(CloundFlare 클라우드 스토리지, Creem/Stripe/PayPal과 같은 제3자 결제 게이트웨이 등)되며, 데이터 처리 계약을 체결해야 함" },
                        { "bold": "법적 요구사항", "text": "유효한 소환장, 법원 명령 또는 당사에 적용되는 기타 법적 절차를 받았을 때" }
                    ]
                },
                {
                    "title": "6. 귀하의 권리",
                    "description": "귀하가 위치한 지역의 적용 법률에 따라 다음과 같은 권리가 있을 수 있습니다:",
                    "items": [
                        { "text": "개인 데이터 사본에 대한 접근" },
                        { "text": "부정확하거나 불완전한 정보 수정" },
                        { "text": "데이터 삭제 권리('잊혀질 권리'), 당사가 보유할 합법적인 이유가 없는 한" },
                        { "text": "특정 유형의 데이터 처리에 대한 반대 또는 제한" },
                        { "text": "데이터 이동성 권리, 데이터 전송을 요청할 수 있음" }
                    ]
                },
                {
                    "title": "7. 어린이 개인정보",
                    "description": "당사 서비스는 16세 미만의 미성년자를 대상으로 하지 않습니다. 일반 데이터 보호 규정(GDPR) 제8조에 따르면, 16세 미만 어린이의 동의는 부모 또는 보호자가 제공해야 합니다. 16세 미만의 미성년자가 당사에 개인 정보를 제공했다는 사실을 알게 되면 즉시 clixmagicai@gmail.com으로 연락해 주세요."
                },
                {
                    "title": "8. 이 정책의 변경",
                    "description": "당사는 이 개인정보 보호정책을 주기적으로 업데이트할 수 있습니다. 중요한 변경 사항이 있을 경우 이 페이지에 새 정책을 게시하고 '최종 업데이트' 날짜를 업데이트하여 알려드립니다. 중요한 변경 사항의 경우, 이메일 또는 기타 눈에 띄는 방식으로 사용자에게 알립니다."
                },
                {
                    "title": "9. 연락처",
                    "description": "이 개인정보 보호정책에 관한 질문이 있으시면 clixmagicai@gmail.com으로 연락해 주세요. 귀하의 데이터가 부적절하게 처리되었다고 생각하거나 우려 사항이 있는 경우 언제든지 연락해 주시기 바랍니다."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. 쿠키란",
                    "description": "쿠키는 웹사이트를 방문할 때 컴퓨터나 모바일 장치에 배치되는 작은 텍스트 파일입니다. 이를 통해 웹사이트는 귀하의 장치를 인식하고 이전에 해당 사이트를 방문했는지 기억할 수 있습니다."
                },
                {
                    "title": "2. 쿠키 사용 방법",
                    "description": "ClixMagicAI은 다양한 목적으로 쿠키를 사용합니다:",
                    "items": [
                        { "bold": "필수 쿠키", "text": "당사 웹사이트의 기본 기능(세션 관리 및 보안 기능 등)에 필요합니다" },
                        { "bold": "기본 설정 쿠키", "text": "Google 또는 GitHub를 통해 로그인한 후 아바타, 사용자 이름 등의 정보를 기억하는 등 경험을 향상시키기 위해 설정 및 선호도를 저장합니다" },
                        { "bold": "분석 쿠키", "text": "익명 정보를 수집하여 방문자가 당사 웹사이트와 어떻게 상호 작용하는지 이해하는 데 도움이 됩니다" },
                        { "bold": "마케팅 쿠키", "text": "귀하의 탐색 습관을 추적하여 관련 광고를 제공합니다" }
                    ]
                },
                {
                    "title": "3. 사용하는 쿠키 유형",
                    "subsection": [
                        {
                            "title": "3.1 필수 쿠키",
                            "description": "이 쿠키는 웹사이트의 올바른 작동에 필요합니다. 보안, 네트워크 관리 및 계정 액세스(Google 및 GitHub 로그인 포함)와 같은 핵심 기능을 활성화합니다. 브라우저에서 이러한 쿠키를 차단하도록 설정할 수 있지만 웹사이트의 일부가 제대로 작동하지 않을 수 있습니다."
                        },
                        {
                            "title": "3.2 성능 및 분석 쿠키",
                            "description": "이 쿠키는 익명 정보를 수집하여 방문자가 당사 웹사이트와 어떻게 상호 작용하는지 이해하는 데 도움이 됩니다. 당사는 이 데이터를 사용하여 웹사이트와 서비스를 개선합니다. 이 쿠키는 방문자를 식별할 수 있는 정보를 수집하지 않습니다."
                        },
                        {
                            "title": "3.3 기능 쿠키",
                            "description": "이 쿠키를 통해 당사 웹사이트는 Google 또는 GitHub를 통한 로그인 상태 기억과 같은 향상된 개인화된 기능을 제공하기 위해 언어 기본 설정이나 로그인 상태와 같은 귀하가 선택한 사항을 기억할 수 있습니다."
                        },
                        {
                            "title": "3.4 타겟팅 및 광고 쿠키",
                            "description": "이 쿠키는 방문자에게 관련 광고를 표시하고 당사 광고 캠페인의 효과를 추적하는 데 사용됩니다. 당사 웹사이트는 주로 제3자 로그인(Google 및 GitHub)에 의존하므로 이러한 쿠키는 주로 사용자 경험을 향상시키는 데 사용되며 직접 마케팅에는 사용되지 않는다는 점에 유의하세요."
                        }
                    ]
                },
                {
                    "title": "4. 쿠키 관리",
                    "description": "쿠키는 다양한 방법으로 제어하고 관리할 수 있습니다. 대부분의 웹 브라우저에서는 쿠키 기본 설정을 관리할 수 있습니다. 다음을 수행할 수 있습니다:",
                    "items": [
                        { "text": "장치에서 쿠키 삭제" },
                        { "text": "일부 또는 모든 쿠키를 거부할 수 있는 브라우저 설정을 활성화하여 쿠키 차단" },
                        { "text": "쿠키를 수신할 때 알림을 받도록 브라우저 설정" }
                    ]
                },
                {
                    "title": "5. 제3자 쿠키",
                    "description": "일부 쿠키는 제3자가 당사 웹사이트에 배치합니다. 이러한 제3자에는 분석 서비스(Google Analytics 등) 및 광고 네트워크가 포함될 수 있습니다. 쿠키의 작동 방식 때문에(쿠키는 원래 설정한 당사자만 액세스할 수 있음) 당사는 이러한 제3자 쿠키의 사용을 제어하거나 액세스할 수 없습니다. Google 및 GitHub를 통해 로그인하는 사용자의 경우, 당사는 관련 정보를 처리할 때 이러한 플랫폼의 개인정보 보호 지침을 준수할 것입니다."
                },
                {
                    "title": "6. 이 쿠키 정책 업데이트",
                    "description": "당사는 기술, 규정 또는 비즈니스 관행의 변화를 반영하기 위해 때때로 이 쿠키 정책을 업데이트할 수 있습니다. 모든 변경 사항은 이 페이지에 게시되며 개정 날짜가 업데이트됩니다."
                },
                {
                    "title": "7. 연락처",
                    "description": "당사의 쿠키 사용에 관한 질문이 있으시면 clixmagicai@gmail.com으로 연락해 주세요."
                }
            ]
        }
    },
    FAQ: {
        title: "ClixMagicAI 사용 가이드 및 자주 묻는 질문",
        prompt: "문제가 있거나 질문이 있으신가요? 언제든지 연락주세요: clixmagicai@gmail.com",
        questions: [
            {
                id : 1,
                question: "ClixMagicAI이란 무엇이며 어떻게 작동하나요?",
                answer: "ClixMagicAI은 고급 AI 기반 워터마크 제거 도구입니다. 이미지와 비디오의 워터마크를 자동으로 식별하고 수동으로 워터마크 위치를 표시하는 기능을 제공합니다. 이미지의 경우, 다양한 형식 변환을 지원하고 고품질 출력을 보장합니다. 비디오의 경우, 정적, 동적, 심지어 형태가 변하는 워터마크도 처리할 수 있습니다."
            },
            {
                id : 2,
                question: "ClixMagicAI은 무료로 사용할 수 있나요?",
                answer: "네, 매일 10포인트의 기본 무료 서비스를 제공합니다! 이를 사용하여 이미지(작업당 1포인트 소비) 또는 비디오(작업당 3포인트 소비)를 처리할 수 있습니다. 현재는 추가 포인트 구매를 지원하지 않으며, 매일 제공되는 10포인트만 사용할 수 있습니다."
            },
            {
                id : 3,
                question: "추가 포인트를 구매할 수 있나요?",
                answer: "현 단계에서는 추가 포인트 구매가 지원되지 않습니다. 모든 사용자는 매일 10개의 무료 포인트만 받을 수 있으며, 다음 날 자동으로 갱신됩니다."
            },
            {
                id : 4,
                question: "어떤 파일 형식을 지원하나요?",
                answer: "이미지의 경우, PNG, JPEG, JPG, WEBP, HEIC, HEIF 형식을 지원하며, HEIC와 HEIF는 자동으로 PNG로 변환됩니다. 비디오의 경우, MP4, MOV를 포함한 여러 형식을 지원합니다."
            },
            {
                id : 5,
                question: "개인정보는 어떻게 보호되나요?",
                answer: "ClixMagicAI에서는 사용자 개인정보를 매우 중요하게 생각합니다. 업로드된 모든 파일은 암호화되어 처리되며, 처리 완료 후 24시간 내에 자동으로 삭제됩니다. 사용자 파일이나 관련 정보를 저장하지 않습니다."
            },
            {
                id : 6,
                question: "ClixMagicAI에 어떻게 로그인할 수 있나요?",
                answer: "GitHub 또는 Google 계정을 통해 빠르게 로그인할 수 있어, 계정 보안을 보장하는 동시에 등록 과정을 간소화합니다."
            },
            {
                id : 7,
                question: "처리 속도는 얼마나 빠른가요?",
                answer: "고성능 서버와 최적화된 AI 알고리즘 덕분에 대부분의 이미지 워터마크 제거 작업은 10초 내에 완료되며, 비디오 워터마크 제거는 최소 1분밖에 걸리지 않습니다. 실제 시간은 파일 크기와 복잡성에 따라 달라질 수 있습니다."
            },
            {
                id : 8,
                question: "처리 후의 효과는 어떤가요?",
                answer: "AI 모델은 광범위한 훈련을 거쳐 이미지와 비디오의 워터마크를 원본 콘텐츠의 품질을 유지하면서 지능적으로 제거할 수 있습니다. 자동으로 인식되거나 수동으로 표시된 워터마크 모두 효과적으로 제거되어 최종 결과물이 자연스럽고 흔적이 남지 않도록 보장합니다."
            },
            {
                id : 9,
                question: "각 작업의 유효 기간은 얼마인가요?",
                answer: "작업이 완료되면 처리된 파일은 사용자가 다운로드할 수 있도록 ClixMagicAI에 24시간 동안 보관됩니다. 기간이 만료된 후에는 개인정보 보호를 위해 파일이 서버에서 자동으로 삭제됩니다."
            },
            {
                id : 10,
                question: "최대 파일 크기 제한은 얼마인가요?",
                answer: "허용되는 최대 이미지 파일 크기는 10MB, 비디오 파일은 최대 100MB입니다. 이 제한을 초과하는 파일은 업로드하기 전에 압축하거나 잘라야 할 수 있습니다."
            }
        ]
    },
}